import React, { useEffect } from 'react';
import { Auth0Provider } from './Auth0Context';
import PropTypes from 'prop-types';
import { isGeminiUser } from '../utils/sessionUtil';
import { recordError } from '../utils/commonUtil';
let isTokenfail=false;
/** Function to clear session storage and logout from DP as well as Auth0. 
 * @param {string} fromPage - to show logout messages in Drupal. 
 */
const logOut = (fromPage='') => {
    const { auth0 } = window;
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem("hasLoggedOut", true);
    if(fromPage) {
        sessionStorage.setItem("fromPage", fromPage);
    }
    if(auth0) {
        auth0.logout();
    } else {
        return false;
    }
    return true;
}

/**
 * Common function to call recordError method
 */
const recordErrNoAuth = (e) => {
    isTokenfail = true;
    recordError(e,'',false).then(() => logOut()).catch(() => logOut())
}

/**
 * Function to get the jwt token from auth0
 */
const getJwtToken = async () => {
    const { auth0 } = window;
    let token = '';    
    if(!isGeminiUser() && auth0) {
        try {
            token = await auth0.getTokenSilently();            
        }
        catch(e) {
            if(!isTokenfail){
            recordErrNoAuth(e);
            }
        }
    } else {
        let tokenInfo = JSON.parse(sessionStorage.getItem("tokenInfo"));
        if(tokenInfo) {
            token = tokenInfo.access_token;
        }
    }
    return token;
}

/**
 * Function to get Auth0 user information details from auth0
 */
const getAuth0UserInfo = async () => {
    let token = ''; 
    const { auth0 } = window;  
    if(auth0) {
        try {
            token = await auth0.getTokenSilently(); 
            if(token){
                return await auth0.getUser();
            }              
        }
        catch(e) {
            recordErrNoAuth(e);
        }
    } 
}

const SessionProvider = (props) => {

    const { children, handleCallback } = props;

    const { auth0 } = window;
    
    const isCsrUser = isGeminiUser();  
    useEffect(() => {
        if(!isCsrUser) {
            (async () => {
                let query = window.location.search;
                if(query.includes('code=') && query.includes('state=')) {
                    try {
                        await auth0.handleRedirectCallback();
                        handleCallback();                        
                    }
                    catch(e) {
                        recordErrNoAuth(e);               
                    }
                }
                else {
                    handleCallback();
                }
            })();            
        } else {            
            handleCallback(isCsrUser);
        }

    }, []);

    return(
        <Auth0Provider value={{auth0}}>
            {children}
        </Auth0Provider>
    )
}

SessionProvider.propTypes = {    
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    handleCallback: PropTypes.func 
}

export { logOut, getJwtToken, getAuth0UserInfo};

export default SessionProvider;